class dataProcessFunctions {
  assignCellValuesWithFieldValueMain(
    templateObj,
    data,
    divisor,
    internalObjByFields
  ) {
    let childObjs = internalObjByFields
      ? internalObjByFields.reduce((p, c, i) => ((p[c] = data[c]), p), {})
      : {};
    templateObj.forEach((i, index) => {
      if ("displayTemplate" in i) {
        data[i.field].forEach((k) => {
          i.displayTemplate.forEach((c) => {
            c.value.push(k[c.field]);
          });
        });
      } else if (typeof i.format === "function") {
        i.value = i.format(data);
      } else if (
        typeof i.field === "string" &&
        (i.value === "" || typeof i.value === "undefined")
      ) {
        i.value =
          "childObjKey" in i
            ? childObjs[i.childObjKey][i.field]
            : data[i.field];
      } else if (
        Array.isArray(i.field) &&
        (i.value === "" || typeof i.value === "undefined")
      ) {
        let srcData = "childObjKey" in i ? childObjs[i.childObjKey] : data;
        let val1st = srcData[i.field[0]];
        let val2nd = srcData[i.field[1]];
        i.value =
          val1st !== "" || val2nd !== ""
            ? divisor.replace("$1", val1st).replace("$2", val2nd)
            : "";
      }
    });
    return templateObj;
  }
  assignCellValuesWithSingleFieldValue(templateObj, data) {
    return this.assignCellValuesWithFieldValueMain(templateObj, data, "", null);
  }
  assignCellValuesWithFieldValueConcat(templateObj, data) {
    return this.assignCellValuesWithFieldValueMain(
      templateObj,
      data,
      "$1 ($2)",
      null
    );
  }
  assignCellValuesWithFieldValueConcatInNewline(
    templateObj,
    data,
    internalObjByFields = null
  ) {
    return this.assignCellValuesWithFieldValueMain(
      templateObj,
      data,
      "$1<br/>$2",
      internalObjByFields
    );
  }
  assignCellValueWithClick(templateObj, data) {
    return this.assignCellValuesWithFieldValueMain(templateObj, data, "", null);
  }
  assignCellTableValuesMain(
    templateObj,
    data,
    internalObjByFields = null,
    isFieldPriority = false
  ) {
    let childObjs = internalObjByFields
      ? internalObjByFields.reduce(
          (p, c, i) => ((p[c] = this.getPropByString(data, c)), p),
          {}
        )
      : {};
    templateObj.forEach((i, index) => {
      if (!("tableSpec" in i)) {
        if (
          typeof i.field === "string" &&
          (i.value === "" || typeof i.value === "undefined")
        ) {
          i.value =
            "childObjKey" in i
              ? childObjs[i.childObjKey][i.field]
              : (data[i.field] || data[i.field] === "") && "otherField" in i
              ? data[i.otherField]
              : data[i.field];
        } else if (typeof i.field === "string" && Array.isArray(i.value)) {
          i.value =
            "childObjKey" in i
              ? childObjs[i.childObjKey].map((k) => k[i.field])
              : [];
        } else if (Array.isArray(i.field) && !isFieldPriority) {
          let srcData = "childObjKey" in i ? childObjs[i.childObjKey] : data;
          let val1st = srcData[i.field[0]];
          let val2nd = srcData[i.field[1]];
          i.value =
            val1st !== "" || val2nd !== "" ? `${val1st} (${val2nd})` : "";
        }
      } else if (typeof i.field === "string" && i.field !== "") {
        "childObjKey" in i
          ? childObjs[i.childObjKey][i.field].forEach((z) => {
              i.tableSpec.forEach((c) => {
                c.value.push(z[c.field]);
              });
            })
          : data[i.field].forEach((z) => {
              i.tableSpec.forEach((c) => {
                c.value.push(z[c.field]);
              });
            });
      } else if (Array.isArray(i.field) && isFieldPriority) {
        "childObjKey" in i
          ? childObjs[i.childObjKey][i.field].forEach((k) => {
              i.tableSpec.forEach((c) => {
                typeof c.field === "string"
                  ? c.value.push(k[c.field])
                  : k[c.field[0]] !== ""
                  ? c.value.push(k[c.field[0]])
                  : c.value.push(k[c.field[1]]);
              });
            })
          : data.forEach((k) => {
              i.tableSpec.forEach((c) => {
                typeof c.field === "string"
                  ? c.value.push(k[c.field])
                  : k[c.field[0]] !== ""
                  ? c.value.push(k[c.field[0]])
                  : c.value.push(k[c.field[1]]);
              });
            });
      } else if ("tableSpec" in i && Array.isArray(data)) {
        data.forEach((k) => {
          i.tableSpec.forEach((c) => {
            let value =
              typeof k[c.field] != "undefined"
                ? k[c.field]
                : typeof k[c.otherField] != "undefined"
                ? k[c.otherField]
                : "";
            c.value.push(value);
          });
        });
      }
    });
    return templateObj;
  }
  assignCellTableValues(templateObj, data, internalObjByFields = null) {
    return this.assignCellTableValuesMain(
      templateObj,
      data,
      internalObjByFields
    );
  }
  assignCellTableValuesWithFieldsSelectByPriority(templateObj, data) {
    return this.assignCellTableValuesMain(templateObj, data, null, true);
  }
  assignMultiValueTableValues(templateObj, data) {
    console.log("assignMultiValueTableValues", data);
    templateObj.forEach((i, index) => {
      if (
        typeof i.field === "string" &&
        "multiValueTableSpec" in i &&
        Array.isArray(data[i.field])
      ) {
        data[i.field].forEach((k) => {
          i.multiValueTableSpec.forEach((c) => {
            if (typeof c.field === "string") {
              c.value.push(k[c.field]);
            } else if (typeof c.field === "object") {
              let tmpRecord = [];
              c.field.forEach((cf) => {
                tmpRecord.push(k[cf.name]);
              });
              c.value.push(tmpRecord);
            }
          });
        });
      }
    });
    return templateObj;
  }
  getPropByString(obj, propString) {
    if (!propString) return obj;

    var prop,
      props = propString.split(".");

    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
      prop = props[i];

      var candidate = obj[prop];
      if (candidate !== undefined) {
        obj = candidate;
      } else {
        break;
      }
    }
    return obj[props[i]];
  }
}
export { dataProcessFunctions };
